module.exports = __webpack_public_path__ + "img/tyopoytakuva.92f68269.webp";